export const getAbsoluteCurrentUrl = () =>
  `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
